import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SelectOption } from '@bcl/design-system';
import { MonitorWithOptions } from '../../../area.model';
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';

export interface ObservationQuestionsDialogData {
  monitor: MonitorWithOptions;
}

export interface ObservationQuestionsDialogResult {
  observationId: string;
  selectedAnswers: { [key: number]: string };
}

@Component({
  selector: 'app-observation-questions-dialog',
  templateUrl: './observation-questions-dialog.component.html',
  styleUrls: ['./observation-questions-dialog.component.scss'],
})
export class ObservationQuestionsDialogComponent implements OnInit, OnDestroy {
  public monitor: MonitorWithOptions;
  public selectedAnswers: { [key: number]: string } = {};
  public questionsOptions: { [key: number]: SelectOption[] } = {};
  public form: FormGroup;

  private subscription: any;

  constructor(
    public dialogRef: MatDialogRef<ObservationQuestionsDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: ObservationQuestionsDialogData
  ) {
    this.monitor = data.monitor;
    dialogRef.disableClose = true;
    dialogRef.keydownEvents().subscribe((event) => {
      if (event.key === 'Escape') {
        this.onCancel();
      }
    });
  }

  ngOnInit() {
    // Get existing observation details
    const tempObservationDetails = JSON.parse(
      this.monitor?.observation?.details || '{}'
    );

    // Create form group with dynamic controls
    const formGroup: { [key: string]: any } = {};
    for (const question of this.monitor?.observationQuestions || []) {
      this.questionsOptions[question.id] = this.mapOptionsToSelect(
        question.options
      );
      this.selectedAnswers[question.id] =
        tempObservationDetails[question.id] || null;
      formGroup[question.id] = [tempObservationDetails[question.id] || null];
    }

    this.form = this.fb.group(formGroup);

    this.subscription = this.form.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((values) => {
        this.selectedAnswers = values;
      });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  mapOptionsToSelect(options: any[]): SelectOption[] {
    return options.map((option) => ({
      value: option.id.toString(),
      label: option.name,
    }));
  }

  handleCounterInput(value: number, questionId: number) {
    if (value < 0) {
      this.form.get(questionId.toString())?.setValue(0, { emitEvent: false });
    }
  }

  public save(): void {
    const result: ObservationQuestionsDialogResult = {
      observationId: '1', // Setting observation ID to "1" (Change)
      selectedAnswers: this.selectedAnswers,
    };
    this.dialogRef.close(result);
  }

  public onCancel(): void {
    this.dialogRef.close(null);
  }
}
